import TableCompany from '../../features/company/components/TableCompany/TableCompany';

const Company = () => {
  return <TableCompany />;
};
export default Company;
